import { Swiper } from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

const propelInit = function() {
const blocks = document.querySelectorAll('.block-testimonial-card');

blocks.forEach((block) => {
	const slider = block.querySelector(
		'.block-testimonials .swiper:not(.swiper-initialized)'
	);

	const wrapper = block.querySelector('.block-testimonials .swiper-wrapper');

	if (!slider || !wrapper) {
		return;
	}

	let cardsPerRow = 3;

	if (block.hasAttribute('data-cards-per-row')) {
		cardsPerRow = parseInt(block.getAttribute('data-cards-per-row'));
	}

	const parentBlock = slider.closest('.acf-block');
	const mobileGap = parentBlock?.dataset?.mobileSliderGap ?? 16;
	const desktopGap = parentBlock?.dataset?.desktopSliderGap ?? 16;

	const settings = {
		loop: false,
		grabCursor: true,
		spaceBetween: mobileGap,
		slidesPerView: 1,
		modules: [A11y, Navigation, Scrollbar],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: mobileGap,
			},
			768: {
				spaceBetween: desktopGap,
			},
			992: {
				slidesPerView: cardsPerRow,
				spaceBetween: desktopGap,
			},
		},
		scrollbar: {
			el: slider.parentElement.querySelector('.swiper-scrollbar'),
			draggable: true,
		},
	};

	// Deferred two to avoid forced reflow. Make sure CSS makes the block appear the same before and after swiper initializes, to avoid CLS.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(slider, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['testimonial-card'] = window.propel.blocks['testimonial-card'] || {};
window.propel.blocks['testimonial-card'].script = propelInit;
